import React from 'react';
import { Outlet}  from 'react-router-dom';
import Footer from '@containers/KioskFooter';

const Kiosk = () => {
  return (
    <div className="h-100">
      <div className="h-90">
        <Outlet />
      </div>
      <div className="h-10">
        <Footer />
      </div>
    </div>
  );
};

export default Kiosk
